/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface WineBoxCreateUpdateRequestDto { 
    /**
     * Wine box type etc. wooden
     */
    type?: TypeEnum;
    /**
     * Wine box capacity [1, 2, 3, 6, 12]
     */
    size?: SizeEnum;
    /**
     * The identifier of bottle size
     */
    bottleSizeId?: string;
}

export enum TypeEnum {
    WoodenBox = 'wooden_box',
    CardboardBox = 'cardboard_box'
}


export enum SizeEnum {
    OneBottle = 'one_bottle',
    TwoBottles = 'two_bottles',
    ThreeBottles = 'three_bottles',
    SixBottles = 'six_bottles',
    TwelveBottles = 'twelve_bottles'
}




